export const campaignIdsWithExpirationDate: number[] = [902];

export const superiorIdsWithExpirationDate: number[] = [919, 921, 909, 914, 905, 915, 932, 953, 1058, 1139];
